<template>
  <div class="tabClass">
    <el-card>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :key="1" :label="$t('uploadFile.customerLeadTime')" name="customerTime">
          <customerTime v-if="isShow1" />
        </el-tab-pane>
        <el-tab-pane :key="0" :label="$t('uploadFile.regionLeadTime')" name="regionalTimeliness">
          <regionalTimeliness v-if="isShow" />
        </el-tab-pane>
        <el-tab-pane :key="2" :label="$t('uploadFile.branchTimeliness')" name="siteTimeliness">
          <siteTimeliness v-if="isShow2" />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>
<script>
export default {
  name: 'ExpressDeliveryMonitoring',
  components: {
    customerTime: () => import('./components/customerTime.vue'),
    regionalTimeliness: () => import('./components/regionalTimeliness.vue'),
    siteTimeliness: () => import('./components/siteTimeliness.vue')
  },
  data() {
    return {
      activeName: 'customerTime',
      noRouteAssociated: 0,
      isShow: false,
      isShow1: true,
      isShow2: false
    };
  },
  methods: {
    handleClick(tab, event) {
      if (tab.name === 'regionalTimeliness') {
        this.isShow1 = false;
        this.isShow = true;
        this.isShow2 = false;
      }
      if (tab.name === 'siteTimeliness') {
        this.isShow1 = false;
        this.isShow = false;
        this.isShow2 = true;
      }
      if (tab.name === 'customerTime') {
        this.isShow = false;
        this.isShow2 = false;
        this.isShow1 = true;
      }
    }
  }
};
</script>

<style scoped>
.tabClass {
  padding: 0 10px;
}

.tabClass ::v-deep .sheind-table .el-table.el-table th.el-table__cell,
.tabClass ::v-deep .sheind-table2 .el-table.el-table th.el-table__cell,
.tabClass ::v-deep .sheind-table .el-table.el-table .el-table__header-wrapper th.el-table__cell,
.tabClass ::v-deep .sheind-table2 .el-table.el-table .el-table__header-wrapper th.el-table__cell,
.tabClass ::v-deep .sheind-table .el-table.el-table .el-table__fixed-header-wrapper th.el-table__cell,
.tabClass ::v-deep .sheind-table2 .el-table.el-table .el-table__fixed-header-wrapper th.el-table__cell {
  color: #fff !important;
  background-color: #000 !important;
}

.tabClass ::v-deep .sheind-table .el-table.el-table .el-table__body tr.choose-row > td.el-table__cell,
.tabClass ::v-deep .sheind-table .el-table.el-table .el-table__body tr.choose-row:hover > td.el-table__cell {
  background-color: #ffd964 !important;
}

.tabClass ::v-deep .sheind-table2 .el-table.el-table .el-table__body tr.choose-row > td.el-table__cell,
.tabClass ::v-deep .sheind-table2 .el-table.el-table .el-table__body tr.choose-row:hover > td.el-table__cell {
  background-color: #1caa22 !important;
}

.tabClass ::v-deep .sheind-table .el-table.el-table td.el-table__cell,
.tabClass ::v-deep .sheind-table2 .el-table.el-table td.el-table__cell {
  color: #333 !important;
}

.tabClass ::v-deep .sheind-table .table-active,
.tabClass ::v-deep .sheind-table2 .table-active {
  color: #1677ff !important;
}

.tabClass ::v-deep .sheind-table2 .el-table.el-table .el-table__body tr.choose-row > td.el-table__cell,
.tabClass ::v-deep .sheind-table2 .el-table.el-table .el-table__body tr.choose-row:hover > td.el-table__cell {
  color: #333 !important;
}

.tabClass ::v-deep .sheind-table2 .el-table.el-table .el-table__body tr.choose-row .table-active,
.tabClass ::v-deep .sheind-table2 .el-table.el-table .el-table__body tr.choose-row:hover .table-active {
  color: #1677ff !important;
}
</style>
